import {
  Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, AfterViewInit, ViewChild, ChangeDetectorRef,
} from '@angular/core';
import {
  validateCourseRequestGeneralInfo, ROOM_NUMBER_MAX_LENGTH, WEB_URL_MAX_LENGTH,
} from 'src/app/utils/course-validation.utils';
import { RichTextEditorComponent } from 'src/app/components/rich-text-editor/rich-text-editor.component';
import { findCourseTypeByName } from 'src/app/utils/course-type.utils';

@Component({
  selector: 'app-catalog-suggestion-general-info',
  templateUrl: './catalog-suggestion-general-info.component.html',
  styleUrls: [ './catalog-suggestion-general-info.component.scss' ],
})
export class CatalogSuggestionGeneralInfoComponent implements OnChanges, AfterViewInit {
  @Input() course: any;
  @Input() courseTypes: any;
  @Output() validationChange = new EventEmitter<{ isValid: boolean }>();
  @ViewChild('description', { static: false }) descriptionEditor: RichTextEditorComponent;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['course']) {
      // Emit validation status when course changes
      setTimeout(() => {
        this.emitValidationStatus();
      }, 0);
    }
  }

  ngAfterViewInit(): void {
    // Emit validation status after view initializes
    this.cdr.detectChanges();
    setTimeout(() => {
      this.emitValidationStatus();
    }, 100);
  }

  updateCourse = (event: any, parameter: string) => {
    if (parameter === 'description') {
      this.course.description = event;
    } else if (parameter === 'courseType') {
      const selectedCourseType = findCourseTypeByName(this.courseTypes, event?.target?.value);

      if (selectedCourseType) {
        this.course.courseType = selectedCourseType.courseType;
        this.course.courseTypeObject = selectedCourseType;
        event.target.value = selectedCourseType.courseType;
      } else {
        // Clear courseType if input doesn't match any valid type
        this.course.courseType = undefined;
        this.course.courseTypeObject = undefined;
      }
    } else {
      this.course[parameter] = event.target.value;
    }

    // Emit validation status after update
    this.emitValidationStatus();
  }

  asyncToggle = () => {
    if (this.course.async) {
      this.course.anytime = false;
      this.course.courseStartTime = '';
      this.course.courseEndTime = '';
      this.course.courseDate = '';
    }

    // Emit validation status after toggle
    this.emitValidationStatus();
  }

  anytimeToggle = () => {
    if (this.course.anytime) {
      this.course.async = false;
      this.course.startTime = '';
      this.course.endTime = '';
    }

    // Emit validation status after toggle
    this.emitValidationStatus();
  }

  private emitValidationStatus(): void {
    const validation = validateCourseRequestGeneralInfo(this.course);
    this.validationChange.emit({ isValid: validation.isValid });
  }

  checkDisabled = (): boolean => {
    const validation = validateCourseRequestGeneralInfo(this.course);
    return !validation.isValid;
  }

  get webUrlError(): string | null {
    const val = this.course?.webUrl;
    if (val && typeof val === 'string' && val.trim().length > WEB_URL_MAX_LENGTH) {
      return `Web URL must be ${WEB_URL_MAX_LENGTH} characters or less`;
    }
    return null;
  }

  get roomNumberError(): string | null {
    if (this.course?.virtual) return null;
    const val = this.course?.roomNumber;
    if (val && typeof val === 'string' && val.trim().length > ROOM_NUMBER_MAX_LENGTH) {
      return `Room Number must be ${ROOM_NUMBER_MAX_LENGTH} characters or less`;
    }
    return null;
  }
}
